export type Environment = 'local' | 'unstable' | 'testing' | 'production'

export const getEnv = (): Environment => {
  if (process.env.NODE_ENV === 'development' || process.env.BUILD_ENV === 'local') {
    return 'local'
  }

  if (['unstable', 'testing', 'production'].includes(process.env.BUILD_ENV as string)) {
    return process.env.BUILD_ENV as Environment
  }

  return 'production'
}
